import actionTypes from '../constants/action-types';

const currentTheme = (state = null, action) => {
  if (action.type === actionTypes.SET_CURRENT_THEME) {
    return action.payload.currentTheme;
  }

  return state;
};

export default currentTheme;
